export default function Charts() {
  return <div>Excel_Charts</div>;
}
